import { connect } from 'react-redux';

import { getFavorites } from '../../redux/favorites/actions';

import RequestFavoritesData from './RequestFavoritesData';

const mapActionsToProps = {
  getFavorites,
};

const RequestFavoritesDataConnected = connect(null, mapActionsToProps)(RequestFavoritesData);

export default RequestFavoritesDataConnected;
